var path = '/var/www/mmscny-website/src/app/common/components/modal/modal-window.html';
var html = "<div class=\"col-md-12 modal-dialog common-dialog {{size ? 'modal-' + size : 'image-crop'}}\"><div class=modal-content uib-modal-transclude></div></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/modal/modal-window.html
// module id = 652
// module chunks = 0